export interface City {
  name: string,
  zip_code: string[]
}
